import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['shouldGiftRuleHaveSelection', 'giftRules']),
    shouldGiftChoiceBlockBeDisplayed () {
      let shouldBeDisplayed = false
      _.each(this.giftRules, (giftRule) => {
        if (this.shouldGiftRuleHaveSelection(giftRule.id)) {
          shouldBeDisplayed = true
        }
      })
      return shouldBeDisplayed
    }
  },
  methods: {
    filterGiftsWithChoice (giftRulesByGroupIds) {
      return _.filter(giftRulesByGroupIds, (giftRule) => {
        return this.shouldGiftRuleHaveSelection(giftRule.id)
      })
    }
  }
}
